// extracted by mini-css-extract-plugin
module.exports = {"ExclusiveSectionStatusC":"ExclusiveSectionStatusC_ExclusiveSectionStatusC__9GJAS","ef-box":"ExclusiveSectionStatusC_ef-box__TsgmD"};